const directives = {
    global: {
        showLoginNew: true,
        logoMainSrc: '/assets/lp/img/webmotors.svg',
        logoMainAlt: 'Webmotors',
        logoMainHeight: '23px',
        logoPartnerSrc: '/assets/lp/img/santander.svg',
        logoPartnerAlt: 'Santander',
        logoPartnerHeight: '19px',
        logoInventoryEs: '/assets/lp/img/empresa-santander.png',
        lps: {
            hasCRM: true,
            hasStock: true,
            hasMoreFidelity: true,
            hasUniversity: true,
            hasBigDeals: true,
            hasWebmotorsTV: true,
            hasAutoguru: false,
            hasPlans: true,
            hasTips: false,
            hasPluginPro: true,
            hasVision360: true,
            hasRightPartnership: true,
            hasIntegrator: true,
            hasEasySchedule: true,
            hasResale: true,
            hasSurveyed: true,
        },
        hasInterestedSignupButton: true,
        interestedSignupUrl: 'https://ajuda.cockpit.com.br/hc/pt-br/requests/new?ticket_form_id=360001166532',
        helpdeskLink: 'https://ajuda.cockpit.com.br/  ',
        hasSocialLinks: true,
        hasTwitter: true,
        twitterUrl: 'https://twitter.com/webmotors',
        hasFacebook: true,
        facebookUrl: 'https://facebook.com/webmotors',
        hasInstagram: true,
        instagramUrl: 'https://www.instagram.com/webmotors',
        hasAppAppleStore: true,
        appAppleStoreUrl: 'https://apps.apple.com/br/app/revendedor-webmotors/id1069917512',
        hasAppGooglePlay: true,
        appGooglePlayUrl: 'https://play.google.com/store/apps/details?id=br.com.webmotors.webmotorsrevendedor.production',
        policyPrivacyUrl: 'https://www.webmotors.com.br/seguranca/politica-de-privacidade/',
        newLogin: true,
        newFooter: true,
        hasi18nFooter: false,
    },
    webinput: {
        telMask: '(99) 9999-99999',
        telFn: value => !(/^\(?\d{2,3}\)?\s?\w{4,5}-?\w{4,5}$/.test(value)),
        mobileMask: '(99) 9999-99999',
        mobileFn: value => !(/^\(?\d{2,3}\)?\s?\w{4,5}-?\w{4,5}$/.test(value)),
        zipcodeMask: '99999-999',
        zipcodeFn: value => !(/^\w{5}-\w{3}$/.test(value)),
        documentMask: '999.999.999-99',
        documentFn: (value) => {
            const cpf = value.replace(/[^\d]+/g, '');
            let add;
            let rev;
            let i;
            if (cpf === '') {
                return true;
            }
            if (/0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11}/.test(cpf)) {
                return true;
            }
            // Valida 1o digito
            add = 0;
            for (i = 0; i < 9; i++) {
                add += parseInt(cpf.charAt(i), 10) * (10 - i);
            }
            rev = 11 - (add % 11);
            if (rev === 10 || rev === 11) {
                rev = 0;
            }
            if (rev !== parseInt(cpf.charAt(9), 10)) {
                return true;
            }
            // Valida 2o digito
            add = 0;
            for (i = 0; i < 10; i++) {
                add += parseInt(cpf.charAt(i), 10) * (11 - i);
            }
            rev = 11 - (add % 11);
            if (rev === 10 || rev === 11) {
                rev = 0;
            }
            if (rev !== parseInt(cpf.charAt(10), 10)) {
                return true;
            }
            return false;
        },
        documentCompanyMask: '99.999.999/9999-99',
        documentCompanyFn: (value) => {
            const cnpj = value.replace(/\D/g, '');
            let i;
            let tamanho;
            let numeros;
            let soma;
            let pos;
            let resultado;
            if (cnpj === '' || cnpj.length !== 14 || /0{14}|1{14}|2{14}|3{14}|4{14}|5{14}|6{14}|7{14}|8{14}|9{14}/.test(cnpj)) {
                return true;
            }
            // Valida DVs
            tamanho = cnpj.length - 2;
            numeros = cnpj.substring(0, tamanho);
            const digitos = cnpj.substring(tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) {
                    pos = 9;
                }
            }
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado !== parseInt(digitos.charAt(0), 10)) {
                return true;
            }
            numeros = cnpj.substring(0, ++tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) {
                    pos = 9;
                }
            }
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado !== parseInt(digitos.charAt(1), 10)) {
                return true;
            }
            return false;
        },
        equal: input => `Digite um valor igual ao campo "${input && input.previousElementSibling.textContent}"`,
        min: min => `Digite um número maior que ${min}`,
        max: max => `Digite um número menor que ${max}`,
        minMax: (min, max) => `Digite um número entre ${min} e ${max}`,
    },
    login: {
        modules: {
            heroLogos: true,
            heroLogosLeft: true,
            heroLogosRight: true,
            FeatureNavigation: true,
            sectionAbout: true,
            sectionSolutions: true,
            sectionSolutionsTitle: true,
            sectionSolutionsMandala: true,
            sectionSolutionsVideo: true,
            sectionSolutionsDoc: false,
            sectionStore: true,
            sectionLatin: true,
            sectionApp: true,
            sectionAppPoster: true,
            sectionAppStore: true,
            sectionAppStoreApple: true,
            sectionAppStoreGoogle: true,
            sectionInterested: true,
            hasInterestedSignupButton: true,
            sectionLatinInvert: true,
            sectionAboutEmbedLarge: false,
            sectionSolutionBigTitle: false,
            sectionFixedStripe: true,
            sectionCustomHeroContent: false,
        },
        settings: {
            aboutEmbedVideoUrl: 'https://www.youtube.com/embed/ieMwYid6aAc',
            solutionsDocUrl: '',
            mandalaUrl: '/assets/lp/img/solucoes.png',
            storeImage: '/assets/lp/img/store.jpg',
            appPosterUrl: '/assets/lp/img/cockpit-app.png',
            sectionLatinPoster: '/assets/lp/img/map.png',
        }
    },
    header: {
        modules: {
            hasCDN: true,
        },
        settings: {
            intercomId: "skfddf3u",
            logoutLink: `/logout`,
        },
    },
    footer: {
        logoWebmotors: '/assets/img/brands/webmotors-2.svg',
        logoSantander: '/assets/img/brands/santander-2020.svg',
    },
    crm: {
        modules: {
            hasInterestedSignupButton: true,
            sectionFixedStripe: true,
        },
        settings: {
            pathPublic: '/solutions/crm',
            pathLogo: '/assets/lp/img/crm.png',
        },
    },
    inventory: {
        modules: {
            hasInterestedSignupButton: true,
            sectionFixedStripe: true,
        },
        settings: {
            pathPublic: '/solutions/estoque',
            pathLogo: '/assets/lp/img/estoque.png',
        },
    },
    autoguru: {
        modules: {
            hasInterestedSignupButton: true,
        },
        settings: {
            pathPublic: '/solucoes/autoguru',
            pathLogo: '/assets/lp/img/autuguru.svg',
        },
    },
    moreFidelity: {
        modules: {
            hasInterestedSignupButton: false,
        },
        settings: {
            pathPublic: '/solutions/fidelity',
            pathLogo: '/assets/lp/img/fidelidade.png',
        },
    },
    university: {
        modules: {
            hasInterestedSignupButton: true,
        },
        settings: {
            pathPublic: '/solutions/university',
            pathLogo: '/assets/lp/img/universidade.png',
        },
    },
    hotDeals: {
        modules: {
            hasInterestedSignupButton: true,
        },
        settings: {
            pathPublic: '/solutions/hot-deals',
            pathLogo: '/assets/lp/img/feiroes.png',
        },
    },
    webmotorsTV: {
        modules: {
            hasInterestedSignupButton: true,
        },
        settings: {
            pathPublic: '/solutions/webmotorstv',
            pathLogo: '/assets/lp/img/webmotors-tv.png',
        },
    },
    plans: {
        modules: {
            hasInterestedSignupButton: true,
        },
        settings: {
            pathPublic: '/solutions/plans',
            pathLogo: '/assets/lp/img/home-logo-planos.png',
        },
    },
    showroom: {
        modules: {
            hasInterestedSignupButton: true,
        },
        settings: {
            pathPublic: '/solutions/showroom',
            pathLogo: '/assets/lp/img/showroom-14.png',
        },
    },
    easySchedule: {
        modules: {
            hasInterestedSignupButton: true,
            sectionFixedStripe: true,
        },
        settings: {
            pathPublic: '/solutions/easy-schedule',
            pathLogo: '/assets/lp/img/agenda-home-img.png',
        },
    },
    resale: {
        settings: {
            pathPublic: '/solutions/resale',
        },
    },
    pluginPro: {
        settings: {
            pathPublic: '/solutions/pluginpro',
        },
    },
    vision360: {
        settings: {
            pathPublic: '/solutions/vision360',
        },
    },
    rightPartnership: {
        settings: {
            pathPublic: '/solutions/parceriacerta',
        },
    },
    integrator: {
        settings: {
            pathPublic: '/solutions/integrador',
        },
    },
    surveyed: {
        settings: {
            pathPublic: '/solutions/vistoriado',
        },
    },
};
export default directives;